export default () => ({
  wallets: [],
  transactions: [],
  packages: [],
  newBalance: 0,
  transactionDetails: {},
  confirmationAccount: false,
})
